/** Kanoniczne fakty o lokalu — SEO, JSON-LD, kopiowanie na stronę. */
export const SEO_SITE_FACTS = {
  brand: "SZNYT Barbershop",
  legalType: "barbershop i salon fryzjerski męski",
  city: "Warszawa",
  district: "Praga Północ",
  districtFull: "Praga Północ, Warszawa",
  streetAddress: "ul. Wrzesińska 6",
  country: "Polska",
  booksyUrl:
    "https://booksy.com/pl-pl/138044_sznyt-barbershop_barber-shop_3_warszawa",
  instagramUrl: "https://www.instagram.com/sznytbarbershop/",
  facebookUrl:
    "https://www.facebook.com/profile.php?id=100083469366100",
  /** Przybliżone współrzędne — do LocalBusiness / map; zweryfikuj w Mapach Google. */
  geo: { latitude: 52.2546, longitude: 21.0368 },
  servicesShort:
    "strzyżenie męskie, broda, kontury, stylizacja włosów i brody, konsultacje",
  openingNote:
    "Poniedziałek–piątek 9:00–18:00, sobota 9:00–15:00 (godziny mogą ulec zmianie — aktualny grafik w Booksy).",
};
